exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".title[data-v-b943fbbe], .content[data-v-b943fbbe] {\n  font-size: 1rem;\n}\nimg[data-v-b943fbbe] {\n  max-width: 100px;\n  width: 100%;\n  margin: 2rem auto;\n}\n.content[data-v-b943fbbe] {\n  font-weight: 300;\n}\n.title[data-v-b943fbbe], .content[data-v-b943fbbe] {\n  text-align: left;\n}", ""]);

// exports
